module.exports = __webpack_public_path__ + "img/intro_uk.8d0a8e4e.svg";